<template>
    <div v-if="isLoadedPageData" class="content__wrap">
        <div class="rest_list__header" style="flex-flow: row nowrap; justify-content: flex-start; width: auto;">
            <burger_menu
                v-if="isMobileScreen"
                :key="'burger_menu'"
            />
            <div class="courier_new__heading" style="width: auto;">
                <div class="courier_new__heading_back" @click.prevent="clickBackArrow">
                    <div class="courier_new__heading_back_arrow margin_left">
                        <svg>
                            <use xlink:href="/icons/base.svg#back_arrow"></use>
                        </svg>
                    </div>
                    <div class="courier__heading_back_text">
                        {{ __t('O.BACK') }}
                    </div>
                </div>
            </div>
            <div class="rest_list__header_container space-around" style="padding-left: 8px;">
                <header_item_group
                    v-for="item in couriersListGroups"
                    :key="'header_item_group' + item.id"
                    :item="item"
                    :operationName="'courier_list_groups'"
                    @select_item_group="selectItemGroup"
                />
            </div>
        </div>
        <courier_new_menu
            v-if="isCourierMenu"
            :key="'courier_new_menu'"
        />
        <courier_new
            v-else
            :key="'courier_new'"
        />
    </div>

</template>

<script>

import loader_page from "../../loader/LoaderPage.vue";
import {screenSize} from "../../../mixins/screenSize";
import {changeBody} from "../../../mixins/changeBody";
import {createHelpers} from "vuex-map-fields";
import burger_menu from "../../heading/BurgerMenu.vue";
import header_item_group from "../../rest/stop_list/HeaderItemGroup.vue";
import courier_new from "./CourierNew.vue";
import courier_new_menu from "./CourierNewMenu.vue";

const {mapFields: mCouriers} = createHelpers({
    getterType: 'couriers/getCouriersField',
    mutationType: 'couriers/updateCouriersField',
})
export default {
    name: "courier_new_create",
    components: {
        header_item_group,
        burger_menu,
        loader_page,
        courier_new,
        courier_new_menu
    },
    mixins: [screenSize, changeBody],
    data() {
        return {
            isLoadMenu: true,
        }
    },
    created() {
        if(!this.activeItemListGroups) {

        }
    },
    beforeMount() {
        this.$store.dispatch('couriers/SET_STATES_LOADING_LIST', {
            actionName: 'setStatesLoadingList',
            statesLoading: ['ordersPos.loading'],
            stateLoad: true
        });
        this.$store.dispatch('couriers/ORDERS_POS', {
            actionName: 'ordersPos',
            statesLoading: ['ordersPos.loading'],
            eventsList: ['loaded_orders_pos'],
            stateLoad: false,
        });
        EventBus.$on('load_menu_main', this.loadMenuMain);
        EventBus.$on('loaded_orders_pos', this.loadedOrdersPos);
    },
    beforeUnmount() {
        EventBus.$off('load_menu_main', this.loadMenuMain);
        EventBus.$off('loaded_orders_pos', this.loadedOrdersPos);
    },
    methods: {
        loadMenuMain() {
            this.isLoadMenu = false;
        },
        createNewOrder() {
            this.$store.dispatch('couriers/CHANGE_STATE_NEW_COURIER', true);
            //this.$router.push({path: '/new'});

        },
        selectItemGroup(itemHeader) {
            this.$store.dispatch('couriers/SET_ACTIVE_ITEM_LIST_GROUPS', itemHeader);
            this.couriersListGroups.forEach(item => item.isSelect = item === itemHeader);
            // if (itemHeader.id === 1) {
            //     this.$router.push({path: '/new/menu'});
            // }
            if (itemHeader.id === 2) {
                this.createNewOrder();
            }
        },
        loadedOrdersPos() {
            if(this.activeItemListGroups) {
                this.selectItemGroup(this.activeItemListGroups);
                return;
            }
            if (this.ordersPos.data && Array.isArray(this.ordersPos.data) && this.ordersPos.data.length > 0) {
                this.$store.dispatch('couriers/CLICK_ITEM_MENU_COURIERS_POS', this.ordersPos.data[0]);
                this.selectItemGroup(this.couriersListGroups[0]);
            } else {
                this.selectItemGroup(this.couriersListGroups[1]);
            }
        },
        clickBackArrow(){
            this.$store.dispatch('couriers/CHANGE_STATE_NEW_COURIER', false);
            this.$router.push({path: '/courier'});
        }
    },
    computed: {
        ...mCouriers([
            'couriersListGroups',
            'isLoadingOrderPos',
            'ordersPos',
            'activeItemListGroups'
        ]),
        isLoadedPageData() {
            return !this.ordersPos.loading;
        },
        isCourierMenu() {
            return this.couriersListGroups.find(item => item.isSelect)?.id === 1
        }
    }
}
</script>
